import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = signed out
  const [profile, setProfile] = useState(null);
  const [partner, setPartner] = useState(null);

  const loadProfile = useCallback(async () => {
    try {
      const [p, rp] = await Promise.all([api.get("/me/profile"), api.get("/me/partner")]);
      setPartner(rp.data || false);
      setProfile(p.data || false);
    } catch {
      setPartner(false);
      setProfile(false);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadProfile();
    } catch {
      try {
        await api.post("/auth/refresh");
        const { data } = await api.get("/auth/me");
        setUser(data);
        loadProfile();
      } catch {
        setUser(false);
        setProfile(false);
        setPartner(false);
      }
    }
  }, [loadProfile]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const signedIn = (u) => {
    setUser(u);
    loadProfile();
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setProfile(false);
    setPartner(false);
  };

  return (
    <AuthCtx.Provider value={{ user, profile, setProfile, partner, setPartner, loadProfile, signedIn, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
